export const getAdminMobile = (): string => {
  try {
    const s = localStorage.getItem('ak_dashboard_session');
    return s ? (JSON.parse(s).mobile || '') : '';
  } catch {
    return '';
  }
};
